import { render, staticRenderFns } from "./outstorage.vue?vue&type=template&id=2c9c0e08&"
import script from "./outstorage.vue?vue&type=script&lang=js&"
export * from "./outstorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports